import { render, staticRenderFns } from "./station-list.vue?vue&type=template&id=4b6d5070"
import script from "./station-list.vue?vue&type=script&lang=js"
export * from "./station-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports